<template>
  <div class="d-flex">
    <div class="dropdown">
      <button class="btn btn-secondary dropdown-toggle fw-normal" type="button" data-toggle="dropdown" aria-expanded="false">
        {{ $t("sort_by") }} <strong class="d-inline-block ms-1">{{ sortingLabel }}</strong>
      </button>
      <ul class="dropdown-menu">
        <li
          v-for="Options of selectOptions"
          :key="Options.id"
        >
          <span class="dropdown-item" @click.prevent="changeSorting(Options.value)">{{ Options.text }}</span>
        </li>
      </ul>
    </div>
    <div class="product-sort-selected" @click.prevent="changeSortingDir(sortingDir)">
      <i v-if="sortingDir === 'ASC'">&uarr;</i>
      <i v-else>&darr;</i>
    </div>
  </div>
</template>

<script>
import config from "@config";
export default {
  name: "CategoryPageContentFilter",
  data() {
    return {
      sortingDir: "ASC"
    };
  },
  mounted() {
    const { page } = this.$route.query;
    if (page && this.totalPages < parseInt(page)) {
      const path = "/" + this.category.url_path;
      const query = { ...this.$route.query };
      delete query["page"];

      this.$router.replace({ path, query });
    }
  },
  computed: {
    selectOptions() {
      const sortOpt = [];
      Object.keys(config.sortingOptions).forEach((element) => {
        if(!element.includes("_down")){
          const option = {
            value: element,
            text: this.$t(`sortingOptions.${element}`),
          };
          sortOpt.push(option);
        }
      });
      return sortOpt;
    },
    sorting() {
      return this.$store.getters["category/getSorting"];
    },
    sortingLabel() {
      let label = "";
      if(this.sorting && this.selectOptions.length > 0){
        this.selectOptions.forEach((element) => {
          if(element.value && element.text && (element.value === this.sorting || element.value === this.sorting.replace("_down", "_up") || element.value === this.sorting.replace("oldest", "newest"))){
            label = element.text;
          }
        });
      }
      return label;
    },
    category() {
      return this.$store.getters["category/getCurrentCategory"];
    },
  },
  methods: {
    changeSortingDir(dir) {
      if(dir == "DESC"){
        if(this.sorting.includes("_down")){
          this.changeSorting(this.sorting.replace("_down", "_up"));
        }else if(this.sorting == "oldest"){
          this.changeSorting(this.sorting.replace("oldest", "newest"));
        }
      }else if(dir == "ASC"){
        if(this.sorting.includes("_up")){
          this.changeSorting(this.sorting.replace("_up", "_down"));
        }else if(this.sorting == "default"){
          this.changeSorting(this.sorting.replace("default", "position_down"));
        }else if(this.sorting == "newest"){
          this.changeSorting(this.sorting.replace("newest", "oldest"));
        }
      }
      if(dir == "ASC"){
        this.sortingDir = "DESC";
      }else if(dir == "DESC"){
        this.sortingDir = "ASC";
      }
    },
    changeSorting(sortVal) {
      this.sortingDir = "ASC";
      this.$store.commit("category/setSorting", sortVal);

      const { path } = this.$route;
      const query = { ...this.$route.query };

      const { sortDefault } = config;
      if (config.sortingOptions[sortVal] && sortVal !== sortDefault) {
        query["sort"] = sortVal;
      } else {
        delete query["sort"];
      }
      delete query["page"];

      this.$router.replace({ path, query });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-type {
  font-size: 16px;
  font-weight: normal;
  margin-right: 12px;
}

.filter-items {
  font-size: 14px;
  li {
    margin-top: 10px;
    margin-bottom: 10px;
    + li {
      margin-left: 14px;
    }
  }
}

.filter-items-btn {
  border: 1px solid $borderColor;
  padding: 4px 22px;
  transition: none;
  display: block;

  &:hover {
    color: $white !important;
  }
}

.select-wrapper {
  position: relative;
}

select {
  font-size: 12px;
  border: 1px solid $borderColor;
  padding: 8px 55px 8px 10px;
  line-height: 1;
  -moz-appearance: none;
  -webkit-appearance: none;
  &:focus {
    box-shadow: none;
    border-color: currentColor;
  }
}

select::-ms-expand {
  display: none;
}
</style>
